import React, { useEffect } from "react";
import { MuiThemeProvider } from "@material-ui/core/styles";
import { Outlet } from "react-router-dom";
import "./App.css";
import { ErrorBoundary } from "./components/common/ErrorBoundaryComponent";
import { IntlProvider } from "react-intl";
import NotificationSnack from "./components/common/NotificationSnack";
import TopMenuComponent from "./components/landing/TopMenuComponent";
import messages_en from "./translations/en.json";
import FooterComponent from "./components/landing/FooterComponent";
import { makeStyles } from "@material-ui/core/styles";
import imageBackgroundApp from "./images/gen/fondo-desktop.jpg";
import { GENOME_THEME } from "./utils/theme";
import { useDispatch } from "react-redux";
import { mobileVersionActionCreator } from "./reducers/commonState";
import { BREAKPOINT_MD } from "./utils/constants";

const messages = {
  en: messages_en,
};

const useStyles = makeStyles((theme) => ({
  appRoot: {
    minHeight: "100vh",
    backgroundImage: "url(" + imageBackgroundApp + ");",
    backgroundPosition: "center",
    backgroundSize: "cover",
    display: "grid",
    gridTemplateRows: "auto 1fr auto",
    flexDirection: "column",
    alignItems: "center",
  },
  main: {
    color: theme.palette.primary.main,
    overflow: "hidden",
    display: "grid",
    alignContent: "center",
    maxWidth: "1200px",
    margin: "0 auto",
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      padding: 0,
    },
  },
}));

export default function App() {
  const locale = { locale: "en", messages: messages["en"] };
  const classes = useStyles();
  const dispatch = useDispatch();

  const handleMobileVersion = () => {
    dispatch(mobileVersionActionCreator(window.innerWidth < BREAKPOINT_MD));
  };

  useEffect(() => {
    handleMobileVersion();
    window.addEventListener("resize", handleMobileVersion);
    return () => {
      window.removeEventListener("resize", handleMobileVersion);
    };
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.innerWidth]);

  return (
    <IntlProvider locale={locale.locale} messages={locale.messages} defaultLocale="en">
      <MuiThemeProvider theme={GENOME_THEME}>
        <div className={classes.appRoot}>
          <ErrorBoundary key={"landingErrorBoundary"}>
            <TopMenuComponent />
            <main className={classes.main}>
              <Outlet />
            </main>
            <FooterComponent />
          </ErrorBoundary>
          <NotificationSnack />
        </div>
      </MuiThemeProvider>
    </IntlProvider>
  );
}
